import React, { useState, useEffect} from "react";
import infoImg from "../../assets/images/info.svg";
import cross from "../../assets/images/cross.svg";
import folder from "../../assets/images/folder.svg";
// import gameFrame from "../../assets/images/game-frame.svg";
import deleteWhite from "../../assets/images/delete-white.svg";
import recommendedVideoPlaceholder from "../../assets/images/recommended-video-placeholder.svg";
// import videoplayback from "../../assets/videos/videoplayback.mp4";
import { Link } from "react-router-dom";
import ReactPlayer from "react-player";
import "./timeline.scss";
import { getGameFile } from "../../services/gameFile";
import { useNavigate, useLocation, } from "react-router-dom";
import TimelineDuration from "./timeline-duration";
import AWS from 'aws-sdk';

// Configure the AWS SDK with your access key and secret key
AWS.config.update({
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_KEY,
  region: process.env.REACT_APP_AWS_REGION,
});


function TimelineScreen() {
  const [state, setstate] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const combinedName = location.state?.combinedName || '';
  const vidName = location.state?.vidName || '';
  const [player, setPlayer] = useState({ start: 0, end: null });
  const [string, number] = combinedName.split('-');
  let updatedNumber = parseInt(number);
  const username = localStorage.getItem('username');
  const token = localStorage.getItem('token');
  // let playerRef;
  const [currentTime, setCurrentTime] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [playerRef, setPlayerRef] = useState(null);
  const [smallPlayerRef, setSmallPlayerRef] = useState(null);
  const [emojiClicked, setEmojiClicked] = useState(false);

  

  const videoURL = `https://d2lzom8fkne0uo.cloudfront.net/videos/${combinedName}.webm`

  //const videoURL = `https://d2lzom8fkne0uo.cloudfront.net/videos/WIN_20230322_15_36_34_Pro.mp4`
  const desktopUrl = `https://d2lzom8fkne0uo.cloudfront.net/userfiles/${vidName}`
  const _videoKey = `userfiles/${vidName}`
  

  const greyColor = {
    color: "rgba(255, 255, 255, 0.56)",
  };
  const recommendGameSection = {
    padding: "0px 70px",
    marginTop: "50px",
  };
  const recommendedVideoImg = {
    width: "70px",
    height: "70px",
    objectFit: "cover",
    borderRadius: "8px",
  };
  const containerStyle = {
    position: "relative",
  };
  const videoStyle = {
    borderRadius: "15px",
    objectFit: "cover",
   
  };
  const smallPlayerStyle = {
    position: "absolute",
    top: "10px",
    right: "10px",
    width: "25%",
    height: "25%",
    zIndex: 1,
  };
  const handleEmojiClick = (time) => {
    console.log(`Emoji clicked at ${time} seconds in TimelineScreen.`);
    // Do something with the time data here
      const startTime = Math.max(time - 6, 0);
      setCurrentTime(startTime);
      setIsPlaying(true);
      setEmojiClicked(true); // Set the emojiClicked flag to true when an emoji is clicked
  };
 

  useEffect(() => {
    if (playerRef && smallPlayerRef && isPlaying) {
      playerRef.seekTo(currentTime);
      smallPlayerRef.seekTo(currentTime);
      setEmojiClicked(false); // Reset the flag after seeking to the desired position
    }
  }, [currentTime, playerRef, smallPlayerRef, isPlaying, emojiClicked]);


   const fetchS3Files = async () => {
    try {
      const response = await fetch('https://backend-dot-immersely-ai.nw.r.appspot.com/api/v1/s3-files', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}` // Add this if your endpoint is protected
        }
      });
  
      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }
  
      const data = await response.json();
      console.log('S3 Files:', data);
      return data;
    } catch (error) {
      console.error('There was a problem fetching S3 files:', error);
    }
  }

  const handlePlayerReady = (player) => {
    setPlayerRef(player);
  };
  const handleSmallPlayerReady = (player) => {
    setSmallPlayerRef(player);
  };

  const handlePlayerPlay = () => {
    setIsPlaying(true);
  };

  const handlePlayerPause = () => {
    setIsPlaying(false);
  };


  const handlePlayerSeek = (time) => {
    setCurrentTime(time);
  };
  


  function onplayhandleer(e) {
    setstate(!state);
  };
  
  function onPause(e) {
    onplayhandleer();
  }

  // getGameFile().then(res=>{
  //   console.log('data--',res)
  // })

  return (
    <div className="timeline-sec">
      
      <div className="bgBlue p-4">
        <div className="justify-between align-center">
          <img src={infoImg} alt="info" />
          <button className="actionBtn red" onClick={() => navigate('/upload-new-video')}>
            <img src={cross} alt="info" />
          </button>
        </div>
        <div style={recommendGameSection}>
          <div className="font-20 white poppins">Recommended Games</div>
          <div className="row">
            <div className="col-xl-10 col-lg-9 col-md-9 col-12 mt-4">
              <div className="row">
                <div className="col-lg-4">
                  <div className="recommendVideo">
                    <div className="video-card align-center">
                      <img
                        style={recommendedVideoImg}
                        src={recommendedVideoPlaceholder}
                        alt="recommendedVideoPlaceholder"
                      />
                      <div className="pl-2 font-12 white poppins">
                        <div className="fw-7">Match 1</div>
                        <div>Veigar</div>
                        <div style={greyColor}>K/D/A 10/11/22</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="recommendVideo">
                    <div className="video-card align-center">
                      <img
                        style={recommendedVideoImg}
                        src={recommendedVideoPlaceholder}
                        alt="recommendedVideoPlaceholder"
                      />
                      <div className="pl-2 font-12 white poppins">
                        <div className="fw-7">Match 1</div>
                        <div>Veigar</div>
                        <div style={greyColor}>K/D/A 10/11/22</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="recommendVideo">
                    <div className="video-card align-center">
                      <img
                        style={recommendedVideoImg}
                        src={recommendedVideoPlaceholder}
                        alt="recommendedVideoPlaceholder"
                      />
                      <div className="pl-2 font-12 white poppins">
                        <div className="fw-7">Match 1</div>
                        <div>Veigar</div>
                        <div style={greyColor}>K/D/A 10/11/22</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          
            <div className="col-xl-2 col-lg-3 col-md-3 col-12 mt-4">
              {/* <div style={videoStyle}>
                <ReactPlayer
                  id="camPlayer"
                  className="react-player"
                  url={videoURL}
                  width="100%"
                  height="100%"
                  controls={true}
                  playing={state}
                />
              </div> */}
            </div>
          </div>
          <div className="row">
            <div className="col-xl-10 col-lg-9 col-md-9 col-12">
              <div className="video-sec mt-4">
                <div style={{ ...containerStyle, ...videoStyle }}>
                  <ReactPlayer
                    ref={handleSmallPlayerReady}
                    style={smallPlayerStyle}
                    id="smallPlayer"
                    className="react-player"
                    url={videoURL}
                    width="25%"
                    height="25%"
                    // controls={true}
                    playing={isPlaying}
                    onPlay={handlePlayerPlay}
                    onPause={handlePlayerPause}
                    config={{ file: { attributes: { controlsList: "nodownload" } } }}
                  />
                  <ReactPlayer
                    ref={handlePlayerReady}
                    className="react-player"
                    id="video"
                    url={desktopUrl}
                    width="100%"
                    height="340px"
                    controls={true}
                    // playing={state}
                    playing={isPlaying}
                    // onPlay={onplayhandleer}
                    // onPause={onPause}
                    onPlay={handlePlayerPlay}
                    onPause={handlePlayerPause}
                    onSeek={handlePlayerSeek} // Add onSeek event handler here
                  />
                </div>
                <div className="justify-between mt-4">
                  <div className="align-center">
                    <div className="white fw-6">Gamplay</div>
                    <Link to="/upload-new-video" className="buttonDiv">
                      <img className="ml-3 cursor" src={folder} alt="info" 
                      onClick={() => navigate('/upload-new-video')}/>
                    </Link>
                    <img className="ml-2 cursor" src={deleteWhite} alt="info" 
                    onClick={() => navigate('/upload-new-video')}/>
                  </div>
                  <button className="theme-btn theme-color shareBtn" >Share</button>
                  <button className="theme-btn theme-color" onClick={fetchS3Files}>Fetch S3 Files</button> {/* test Button */}
                </div>
                <div className="mt-5">
                <TimelineDuration onEmojiClick={handleEmojiClick} currentTime={currentTime}/>
                  <div className=""></div>
                  {/* <img className="img-fluid" src={gameFrame} alt="" /> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default TimelineScreen;
